import {
    FormGroup,
    Label,
    Input
} from 'reactstrap';
import { SquareCheckbox } from "../../../../components/Inputs/SquareCheckbox/SquareCheckbox";
import React, { useRef, useEffect, useState } from 'react';

export default function SharedUserSection({ modalData, handleChange, validationErrors, handlePasswordBlur, onPasswordFocus }) {
    const passwordInputRef = useRef(null);

    const hasPageBeenRendered = useRef(false); 

    useEffect(() => {
        if (hasPageBeenRendered.current && modalData.userData.hasPassword) {
            passwordInputRef.current.focus();
        }
        else {
            hasPageBeenRendered.current = true;
        }
    }, [modalData.userData.hasPassword]); // Dependency array ensures this runs when isChecked changes

    return (
        <>
            <FormGroup className="mb-3">
                <div className="d-flex align-items-center mb-1">
                    <Label
                        for="userName"
                        className="me-3 mb-0"
                        style={{ minWidth: '130px' }}
                    >
                        User Name *
                    </Label>
                    <div className="w-100">
                        <Input
                            id="userName"
                            name="userName"
                            value={modalData.userData.userName}
                            className="form-control-sm"
                            placeholder="UserName"
                            onChange={handleChange}
                            invalid={!!validationErrors.userName}
                        />
                        {validationErrors.userName && (
                            <div className="text-danger small mt-1">
                                {validationErrors.userName}
                            </div>
                        )}
                    </div>
                </div>
            </FormGroup>
            <div className="mb-3">
                <SquareCheckbox
                    checkboxClassName="pl-0"
                    value={modalData.userData.hasPassword}
                    label="Require Password"
                    valueChangeHandler={handleChange}
                    name="hasPassword"
                />
            </div>

                <FormGroup className={`mb-3 ${modalData.userData.hasPassword ? '': 'd-none'}`}>
                    <div className="d-flex align-items-center mb-1">
                        <Label for="password" className="me-3 mb-0" style={{ minWidth: '130px' }}>
                            App Password *
                        </Label>
                        <div className="w-100">
                            <Input
                                id="password"
                                className="form-control-sm"
                                name="password"
                                value={modalData.userData.password}
                                onChange={handleChange}
                                onBlur={handlePasswordBlur}
                                invalid={!!validationErrors.password}
                                type="password"
                                placeholder="Enter your password"
                                onFocus={onPasswordFocus}
                                innerRef={passwordInputRef}

                            />
                            {validationErrors.password && (
                                <div className="text-danger small mt-1">{validationErrors.password}</div>
                            )}

                        </div>
                    </div>
                    <div className="text-muted small mb-2 mt-3">
                        <span>*Passwords must be a minimum of 8 characters and use two of the following: lower case letter, capital letter, number, or special character.</span>
                    </div>
                </FormGroup>
        </>
    )
}